export default "__VITE_ASSET__BXoJnUDh__"